/**
 * Submits API requests from the web interface and displays the result
 */

import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/val/val.js";
import "dabbyjs/src/traversal/eq/eq.js";
import "dabbyjs/src/manipulation/insert/insert.js";
import "dabbyjs/src/manipulation/empty/empty.js";

export default obj => {

	// add rows of data
	$("#hash-add").on("click", e => {
		const container = $("#hash-duplicate"),
			items = container.children(),
			newitem = items.eq(0).clone(),
			len = items.length,
			count = $("#hashform-count");
		$("label,input,select", newitem).each(function () {
			const $this = $(this);
			["for", "name", "id"].forEach(item => {
				const attr = $this.attr(item);
				if (attr) {
					$this.attr(item, attr.replace("0", len));
				}
			});
		});
		container.append(newitem);
		count.val(items.length + 1);
		e.preventDefault();
	});

	// submit to API
	obj.on("submit", function (e) {
		const form = $(this),
			data = {},
			headers = {
				accept: "application/json"
			},
			method = form.attr("method"),
			result = $("#hash-result");

		// clear result
		result.empty();

		// get form data
		$("input:not([type=submit],[type=radio]:not(:checked),[type=checkbox]:not(:checked)),select,textarea", form).each(function () {

			// prepare data
			const $this = $(this),
				name = $this.attr("name"),
				val = $this.val();

			// if the data is a header
			if ($this.data("type") === "header") {
				headers[name] = val;

			// check there is a value to set
			} else if (val !== "" && val !== undefined) {

				// get the nested variable keys
				const items = name.split("[").map(item => item.replace("]", ""));

				// build nested objects
				let tmp = data;
				for (let i = 0; i < items.length - 1; i++) {
					if (tmp[items[i]] === undefined) {
						tmp[items[i]] = items[i+1] !== "" && isNaN(items[i+1]) ? {} : [];
					}
					tmp = tmp[items[i]];
				}

				// set the value to the leaf node
				const last = items.pop();
				if (last === "" && Array.isArray(tmp)) {
					tmp.push(val);
				} else {
					tmp[last] = isNaN(val) ? val : parseInt(val);
				}
			}
		});

		// fetch resource
		fetch((form.attr("action") || location.href) + (method !== "POST" ? ("?" + new URLSearchParams(data)).toString() : ""), {
			method: method,
			headers: headers,
			body: method === "GET" ? undefined : JSON.stringify(data)

		// decode data
		}).then(response => {
			const disp = response.headers.get("Content-Disposition"),
				type = response.headers.get("Content-Type");

			// download the file
			if (disp?.startsWith("attachment;")) {
				return response.blob().then(data => ({data, name: disp.split('"')[1]}));

			// parse json lines
			} else if (type?.startsWith("application/jsonlines")) {
				return response.text().then(text => text.split("\n").map(json => JSON.parse(json)));

			// parse json
			} else {
				return response.json();
			}

		// process data
		}).then(json => {

			// deliver download
			if (json.data instanceof Blob) {
				const a = document.createElement("a");
				a.href = URL.createObjectURL(json.data);
				a.download = json.name;
				document.body.appendChild(a);
				a.click();    
				a.remove();

			// display results
			} else {
				$("#hash-result").text((Array.isArray(json) ? json : [json]).map(item => JSON.stringify(item, null, 4)).join("\n\n"));
			}

		// display error
		}).catch(e => {
			$("#hash-result").text(e);
		});
		e.preventDefault();
	});
};